






































import { ElementActionsKeys, ElementActionsPayload } from '@/store/types/element';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { onDrop } from '@/utils/dropFile';
import { Element as CanvasElement } from '@/store/types/element';
import UploadBoxToolbar from '../Toolbars/UploadBoxToolbar.vue';
import { RootGettersReturns } from '@/store/types';

@Component({
  components: {
    UploadBoxToolbar,
  },
})
export default class UploadBoxElement extends Vue {
  @Prop(Boolean) selected!: boolean;
  @Prop(Boolean) isDragging!: boolean;
  @Prop({ type: Object }) element!: CanvasElement;

  @Action(ElementActionsKeys.ADD_ELEMENT) addElement!: (
    payload: ElementActionsPayload['ADD_ELEMENT']
  ) => Promise<ElementActionsPayload['ADD_ELEMENT']>;
  @Action(ElementActionsKeys.UPLOAD_ELEMENT) uploadElement!: (
    payload: ElementActionsPayload['UPLOAD_ELEMENT']
  ) => Promise<ElementActionsPayload['ADD_ELEMENT']>;
  @Action(ElementActionsKeys.SELECT_ELEMENT) selectElement!: (payload: ElementActionsPayload['SELECT_ELEMENT']) => void;
  @Action(ElementActionsKeys.UPDATE_ELEMENT) updateElement!: (payload: ElementActionsPayload['UPDATE_ELEMENT']) => void;

  @Getter sharedBoard!: RootGettersReturns['sharedBoard'];
  @Getter isGuest!: RootGettersReturns['isGuest'];

  dragging = false;
  isUploading = false;

  async mounted() {
    this.$parent.$parent.$emit('changeMoveable', !this.isGuest);
  }

  async onDrop(e: DragEvent) {
    if (this.sharedBoard) return;
    if (e.dataTransfer?.files.length) {
      (this.$refs.fileInput as HTMLInputElement).files = e.dataTransfer.files;
      this.isUploading = true;

      await onDrop({
        e,
        elPosition: { x: this.element.x, y: this.element.y },
        addElement: this.addElement,
        uploadElement: ({ file, element }) =>
          this.uploadElement({ file, element: { ...this.element, ...element }, changeEl: true }),
        afterUpload: async el => {
          this.isUploading = false;
          await this.selectElement(el);
          this.$root.$emit('select', el);
        },
      });
    }
    this.dragging = false;
  }

  async upload() {
    if (this.sharedBoard) return;
    const files = (this.$refs.fileInput as HTMLInputElement).files || (([] as unknown) as FileList);
    this.isUploading = true;
    await onDrop({
      fileList: files,
      elPosition: { x: this.element.x, y: this.element.y },
      addElement: this.addElement,
      uploadElement: ({ file, element }) =>
        this.uploadElement({ file, element: { ...this.element, ...element }, changeEl: true }),
      afterUpload: async el => {
        this.isUploading = false;
        await this.selectElement(el);
        this.$root.$emit('select', el);
      },
    });
  }
}
